export const SWITCH_IPV4_ACL_SECTION_EVENT =
	'canvas-agent:switch-ipv4-acl:section';
export const SWITCH_IPV4_ACL_FOCUS_EVENT =
	'canvas-agent:switch-ipv4-acl:focus';
export const SWITCH_IPV4_ACL_FILTER_EVENT =
	'canvas-agent:switch-ipv4-acl:filter';
export const SWITCH_IPV4_ACL_CREATE_MODAL_EVENT =
	'canvas-agent:switch-ipv4-acl:create-modal';
export const SWITCH_IPV4_ACL_DELETE_MODAL_EVENT =
	'canvas-agent:switch-ipv4-acl:delete-modal';
export const SWITCH_IPV4_ACL_ADD_ACE_EVENT =
	'canvas-agent:switch-ipv4-acl:add-ace';
export const SWITCH_IPV4_ACL_EDIT_ACE_EVENT =
	'canvas-agent:switch-ipv4-acl:edit-ace';
export const SWITCH_IPV4_ACL_DELETE_ACE_EVENT =
	'canvas-agent:switch-ipv4-acl:delete-ace';
